import type { QueueTone } from '@/components/designSystem/QueueViews/types'
import type {
  ActivityRequestLeg,
  ActivityRequestOpeningRule,
  ActivityRequestOrderBy,
  ActivityRequestQuickViewKey,
  ActivityRequestView,
  RegistrationMode
} from '@/types/activity-requests.types'

export const ACTIVITY_REQUESTS_API_PATH = '/ds-attendance/operations/activity-requests'

export const ACTIVITY_REQUEST_VIEWS: readonly ActivityRequestView[] = [
  'OVERDUE',
  'DUE_24H',
  'ON_TIME',
  'ALL'
]
/** M1 decisão 2 — a aba abre em Vencidas. */
export const ACTIVITY_REQUEST_DEFAULT_VIEW: ActivityRequestView = 'OVERDUE'

export const ACTIVITY_REQUEST_ORDER_BY: readonly ActivityRequestOrderBy[] = [
  'DEADLINE',
  'STATION_DATE',
  'OPENED_AT'
]
export const ACTIVITY_REQUEST_DEFAULT_ORDER_BY: ActivityRequestOrderBy = 'DEADLINE'

export const ACTIVITY_REQUEST_ORDER_BY_LABELS: Record<ActivityRequestOrderBy, string> = {
  DEADLINE: 'Prazo (mais urgente primeiro)',
  STATION_DATE: 'Data do plantão',
  OPENED_AT: 'Abertura da solicitação'
}

export const ACTIVITY_REQUEST_PAGE_SIZE = 20

export interface ActivityRequestQuickView {
  key: ActivityRequestQuickViewKey
  label: string
  hint: string
  tone: QueueTone
}

/** M1-B — cartões mutuamente exclusivos; os números vêm de `counters.byView`. */
export const ACTIVITY_REQUEST_QUICK_VIEWS: readonly ActivityRequestQuickView[] = [
  { key: 'OVERDUE', label: 'Vencidas', hint: 'prazo de envio passou', tone: 'crit' },
  { key: 'DUE_24H', label: 'Vencem em 24 h', hint: 'últimas 24 h do prazo', tone: 'warn' },
  { key: 'ON_TIME', label: 'No prazo', hint: 'mais de 24 h para vencer', tone: 'ok' },
  { key: 'REOPENED', label: 'Reabertas', hint: 'após rejeição', tone: 'warn' },
  { key: 'ALL', label: 'Todas', hint: 'aguardando envio', tone: 'neutral' }
]

/**
 * Rótulo da regra de abertura (§4.1.1). O "N" da regra (horas/dias configurados) não vem no
 * payload da §5.2, então o texto nomeia a fonte do número em vez de inventá-lo.
 */
export const ACTIVITY_REQUEST_OPENING_RULE_LABELS: Record<ActivityRequestOpeningRule, string> = {
  SHEET_CONTAINER_DEADLINE: 'Prazo da folha',
  SHEET_FALLBACK_DAYS: 'Fim do dia + dias da política',
  APP_POLICY_SUBMISSION_DEADLINE: 'Prazo da política (23:59 + horas)',
  APP_AFTER_CHECKOUT: 'Fim do plantão + horas do canal',
  EXTERNAL_APP_AFTER_END: 'Fim do plantão + horas do canal',
  REJECTION_REOPEN: 'Rejeição'
}

export const ACTIVITY_REQUEST_LEGS: readonly ActivityRequestLeg[] = ['CHECKIN', 'CHECKOUT', 'BOTH']

/** "Modalidade de registro" (acréscimo do dono, 25/09) — ordem e rótulos literais. */
export const REGISTRATION_MODES: readonly RegistrationMode[] = [
  'MINHA_ESCALA_APP',
  'FOLHA',
  'EXTERNAL_APP'
]

export const REGISTRATION_MODE_LABELS: Record<RegistrationMode, string> = {
  MINHA_ESCALA_APP: 'Registro de check-in e check-out',
  FOLHA: 'Folha da medição da presença médica',
  EXTERNAL_APP: 'App vizinho'
}

/** Sem `@ME:` de propósito: o logout por 401 apaga `@ME:*` e levaria as visões salvas. */
export const ACTIVITY_REQUEST_SAVED_VIEWS_PREFIX = 'activity-requests:views:'
export const ACTIVITY_REQUEST_LAST_QUERY_PREFIX = 'activity-requests:last-query:'

export const ACTIVITY_REQUEST_SEARCH_DEBOUNCE_MS = 300
